import * as React from 'react';
import { Bar } from 'react-chartjs-2';
import { ArcElement, Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

import { theme } from 'configs';
import { IChartData } from 'models';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface BarChartHorizontalProps {
  data: IChartData;
}

export const BarChartHorizontal: React.FC<BarChartHorizontalProps> = (props) => {
  const { data } = props;
  const options = {
    indexAxis: 'y' as const,
    responsive: true,
    aspectRatio: 1.2,
    barPercentage: 0.6,
    borderRadius: 4,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        display: false,
        stacked: true,
      },
      y: {
        display: true,
        stacked: true,
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: theme.palette.primary.main,
          font: {
            weight: 'bold',
            size: 14,
          },
        },
      },
    },
  };

  return <Bar options={options} data={data} />;
};
